import React, { useContext } from "react";
import { Outlet, Navigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";

const PrivateAdminRoutes = () => {
    const { userDetails } = useContext(AuthContext);

    return (
        userDetails && userDetails.user_type === "A" ? <Outlet /> : <Navigate to="/sign-in"/>
    );
};

export default PrivateAdminRoutes;
